import axios from "axios";
import { createMutationGroup } from "../../core/api/mutations";
import { auth } from "../../core/auth";
import { env } from "../../env";
import { components, PdfFormTemplateId } from "../../shared/schema/schema";

type PdfFormField = components["schemas"]["PdfFormField"];

export default createMutationGroup(({ api, createMutation }) => ({
  // Multipart upload — not in the OpenAPI schema, so raw axios like
  // billing/pages/uploads/UploadTab.tsx.
  create: () =>
    createMutation({
      mutationFn: async (params: { file: File; name: string }) => {
        const authState = auth.getAuthOrFail();
        const data = new FormData();
        data.append("name", params.name);
        data.append("file", params.file, params.file.name);
        const response = await axios.post<{ id: PdfFormTemplateId }>(
          `${env.API_URL}agencies/${authState.data.agency.id}/agency_members/${authState.data.agencyMember.id}/pdf_form_templates`,
          data,
          { headers: { Authorization: `Token ${authState.tokens.authToken}` } }
        );
        return response.data;
      },
    }),

  saveDraft: (templateId: PdfFormTemplateId) =>
    createMutation({
      mutationFn: (body: { name?: string; fields: PdfFormField[] }) =>
        api.put("./pdf_form_templates/:pdfFormTemplateId/draft", {
          path: { pdfFormTemplateId: templateId },
          body,
        }),
    }),

  publish: (templateId: PdfFormTemplateId) =>
    createMutation({
      mutationFn: (body: { fields: PdfFormField[] }) =>
        api.post("./pdf_form_templates/:pdfFormTemplateId/versions", {
          path: { pdfFormTemplateId: templateId },
          body,
        }),
    }),

  generatePreview: (templateId: PdfFormTemplateId) =>
    createMutation({
      mutationFn: (body: { fields: { field: PdfFormField; value: string | boolean | null }[] }) =>
        api.post("./pdf_form_templates/:pdfFormTemplateId/generate_preview", {
          path: { pdfFormTemplateId: templateId },
          body,
        }),
    }),

  remove: (templateId: PdfFormTemplateId) =>
    createMutation({
      mutationFn: () =>
        api.delete("./pdf_form_templates/:pdfFormTemplateId", {
          path: { pdfFormTemplateId: templateId },
        }),
    }),
}));
